// extracted by mini-css-extract-plugin
export default {"container_page":"perfect-match_container_page__FyZZQ","text":"perfect-match_text__xa-m3","couple_image":"perfect-match_couple_image__Gn6kn"};